import RelativeTimeElement from './relative-time-element-define.js';
export { RelativeTimeElement };
export default RelativeTimeElement;
export * from './relative-time-element-define.js';
